import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M10.243 19.063C10.093 19.344 10 19.66 10 20.001C10 21.106 10.895 22.001 12 22.001C13.105 22.001 14 21.106 14 20.001C14 19.66 13.907 19.344 13.757 19.063H10.242H10.243ZM16.839 8.23605C16.839 8.23605 16.938 4.87605 13.983 3.82405C13.892 2.80205 13.045 1.99805 12 1.99805C10.953 1.99805 10.104 2.80505 10.017 3.82905C7.07105 4.88705 7.17005 8.23605 7.17005 8.23605C7.17005 8.23605 7.10805 13.237 2.99805 15.839C2.99805 16.791 2.99805 17.99 2.99805 17.99H21.001C21.001 17.99 21.001 16.791 21.001 15.839C16.9 13.237 16.838 8.23605 16.838 8.23605H16.839Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'BellFill');

export default Icon;
